import React from "react";
import { goTo } from "../tools";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';


import '../gnp-registro/gnp-registro-new-movile.css'

const mapState = (state) => {
	let fechaNacimiento = "";
	if (state.registro.fechaNacimiento == "") {
		fechaNacimiento = state.registro.fechaDeNacimiento;
	} else {
		fechaNacimiento = state.registro.fechaNacimiento;
	}

	return {
		initialValues: {
			apaterno: state.registro.apaterno,
			amaterno: state.registro.amaterno,
			nombres: state.registro.nombres
		},
		email: state.registro.email,
		fechaNacimiento: fechaNacimiento,
		ramo: state.registro.ramo,
		poliza: state.registro.poliza,
		certificado: state.registro.certificado,
		inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		}
	};
};

const espacios = tipo => (value, campos) => {
	let texto = (value != undefined && value != " ") ? value : "";
	texto = texto.replace(/\s{2,}/g, " ");
	campos[tipo] = texto;
};

const validate = values => {
	const errors = {};

	if (!values.nombres || values.nombres.trim() == "") {
		errors.nombres = "Campo requerido.";
	}

	if (!values.apaterno || values.apaterno.trim() == "") {
		errors.apaterno = "Campo requerido.";
	}

	if (!values.amaterno || values.amaterno.trim() == "") {
		errors.amaterno = "Campo requerido.";
	}

	return errors;
};
/*
const campo = ({ input, label, type, meta: { touched, error } }) => {
	return (
		<div className="input-wrap">
			<label htmlFor={input.name}>{label}</label>
			<span className="clearfix input-active">
				<div>
					<input {...input} type={type} maxLength="50" />
				</div>
			</span>
			{touched && error &&
				<div className="error-wrap">
					<div className="msj-error">
						<p><span>{error}</span></p>
					</div>
				</div>
			}
		</div>
	);
};
*/

const campo = ({ ...custom, input, label, max, type, focus, blur, change, meta: { touched, error } }) => {
    return (
        <MuiThemeProvider>
            <TextField
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{borderColor: '#AAC3EE'}}
                underlineFocusStyle={{borderColor: '#FF6B0B'}}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                onFocus={focus}
                onBlur={(event) => { input.onBlur(event); blur(event); }}
                onChange={(event) => { console.log(event.target.name);input.onChange(event); change(event); }}
                maxLength={max}
                errorText={touched && error}
            />
        </MuiThemeProvider>

    );
};

const campoSelect = ({
    input,
    label,
    type,
    blur,
    change,
    name,
    meta: { touched, error },
    children,
    ...custom
}) => {
    return (
       
            <MuiThemeProvider>
                <SelectField
                    {...input}
                    name={name}
                    floatingLabelText={label}
                    underlineStyle={{borderColor: '#AAC3EE'}}
                    underlineFocusStyle={{borderColor: '#FF6B0B'}}
                    floatingLabelStyle={floatingLabelStyleSettings}
                    floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                    onBlur={(event,index, value) => { input.onBlur(event); blur(event,index, value, name); }}
                    onChange={(event, index, value) => { input.onChange(value); change(event, index, value, name); }}
                    children={children}
                    fullWidth={true}
                    errorText={touched && error}
                    {...custom}
                    />
                        
            </MuiThemeProvider>
    );
};

const campoSettings = {
    fontFamily:'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
}

const floatingLabelStyleSettings={
        ...campoSettings,
        lineHeight: '24px',
        letterSpacing: '0.5px',
        color: '#0C2040',
}

const floatingLabelFocusStyleSettings={
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: '#FF6B0B',
}
class CompletarForm extends React.Component {
	state = {
		ramo: "Gastos Medicos"
	}

	componentWillMount = () => {
		if (this.props.ramo == "G") {
			this.state.ramo = "Gastos Médicos";
		} else if (this.props.ramo == "D") {
			this.state.ramo = "Daños";
		} else if (this.props.ramo == "V") {
			this.state.ramo = "Vida";
		} else {
			this.state.ramo = "Autos";
		}
	}

	regresar = () => {
		this.props.tagManager({ "type": "EVENT_REGISTRO_ASISTIDO-REGRESAR", "dispositivo": this.props.dispositivo });
		goTo("gnp/registro");
	}
    resetConfiguracion = () => {
        this.props.change("nombres","");
        this.props.untouch("nombres");
        this.props.change("apaterno","");
        this.props.untouch("apaterno");
        this.props.change("amaterno","");
        this.props.untouch("amaterno");
    }
    handleChange = (event) => {
        let tipo = event.target.name;
        let oForm = this.props.dataForm;

        if ( tipo == "nombres" || tipo == "apaterno" || tipo == "amaterno") {
            this.resetConfiguracion();
        }
    }
    handleBlur = (event) => {
        let tipo = event.target.name;
        let oForm = this.props.dataForm;
        if (tipo == "poliza" && oForm.nombres != "" && oForm.apaterno != "" && oForm.amaterno != "" && event.target.value != "") {
            this.resetConfiguracion();
        }
    }
	render() {
		const { handleSubmit, pristine, reset, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="container ">
                <div className="margin-mobile">
                        <div className="row">
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                 <p className="gnp-material-content-registro-e1">Para poder concluir tu registro es importante que nos proporciones la siguiente información:</p>
                            </div>
                        </div>
                    	
                    <div className="margin-mobile">
						<div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
							
								<div className="row">
                                     <div className="col-md-6 col-sm-6 col-xs-12">
										<Field name="nombres" label="Nombre(s)" blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)} component={campo} type="text" validate={espacios("nombres")} />
									</div>
									<div className="col-md-6 col-sm-6 col-xs-12">
										<Field name="apaterno" label="Apellido Paterno" blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)}  component={campo} type="text" validate={espacios("apaterno")} />
									</div>
									<div className="col-md-6 col-sm-6 col-xs-12">
										<Field name="amaterno" label="Apellido Materno" blur={this.handleBlur.bind(this)} change={this.handleChange.bind(this)}  component={campo} type="text" validate={espacios("amaterno")} />
									</div>
									
								</div>
							
                            <div className="">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
									<p className="gnp-material-content-registro-e1">Agradecemos que valides tu información, si es correcta puedes continuar.</p>
                                </div>
                            </div>

							<div className="row">
								
								<div className="">
									<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
										<div className="card">
											<ul className="">
												<li className="">
													<div>
														<p className="gnp-material-content-registro-labelEnc" ><b>Correo electrónico</b></p>
													</div>
													<div>
														<div>
															<p className="gnp-material-content-registro-labelTextLectura">{this.props.email}</p>
														</div>
													</div>
												</li>
												<li>
													<div>
														<p className="gnp-material-content-registro-labelEnc"><b>Fecha de nacimiento</b></p>
													</div>
													<div>
														<div>
															<p className="gnp-material-content-registro-labelTextLectura" >{this.props.fechaNacimiento}</p>
														</div>
													</div>
												</li>
												<li >
													<div>
														<p className="gnp-material-content-registro-labelEnc"><b>Ramo</b></p>
													</div>
													<div>
														<div >
															<p className="gnp-material-content-registro-labelTextLectura">{this.state.ramo}</p>
														</div>
													</div>
												</li>
												<li >
													<div>
														<p className="gnp-material-content-registro-labelEnc"><b>No. póliza o No. referencia</b></p>
													</div>
													<div>
														<div >
															<p className="gnp-material-content-registro-labelTextLectura">{this.props.poliza}</p>
														</div>
													</div>
												</li>
												{this.props.certificado &&
													<li>
														<div>
															<p className="gnp-material-content-registro-labelEnc"><b>No. de certificado</b></p>
														</div>
														<div>
															<div >
																<p className="gnp-material-content-registro-labelTextLectura">{this.props.certificado}</p>
															</div>
														</div>
													</li>
												}
												<li>
													<div>
														<p  className="gnp-material-content-registro-labelEnc"><b>Fecha inicio de vigencia de la póliza</b></p>
													</div>
													<div >
														<div>
															<p className="gnp-material-content-registro-labelTextLectura">{this.props.inicioVigenciaPoliza}</p>
														</div>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
                    </div>
				</div>
				<div className="row" style={{marginLeft: "0px", marginRight: "0px"}}>
					<div className="registro-button-container">
						{/*<div className="col-md-6 col-sm-6 col-xs-12">
							<button type="button" onClick={this.regresar} className="orange-rectangle disabled" style={{ "marginBottom": "10px" }}>Regresar</button>
                                            </div>*/}
						<div className="col-md-12 col-sm-12 col-xs-12">
							<button className="pure-material-button-contained btn-full-width" style={{ "marginBottom": "35px" }}
							 type="submit">Siguiente</button>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

CompletarForm = reduxForm({ form: "registro-asistido-completar" })(CompletarForm);

export default connect(mapState, mapDispatch)(CompletarForm);


// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/complementarWebMovil.frm.js